import React, { Fragment } from 'react';
import { Button, Column, Icon, Table, PageBar, Dialog, Loading, PopOver, OverlayTrigger } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { bindStatus, isNormalAccount } from '../../../consts/multiAccountConfig';

import useTable from '../../../leads_component/shared-components/hooks/useAsyncTable';
import useDialog from '../../../leads_component/shared-components/hooks/useDialog';
import useConfirm from '../../../leads_component/shared-components/hooks/useContentDialog';
import useFeedback from '../../../leads_component/shared-components/hooks/useFeedback';

import FeedBackDialog from '../../common/feedback';
import Confirm from './confirmDialog';
import Bind from './bindDialog';
import { OPERATION_TYPE } from './config';

const MyTable = () => {
  const bindDialogHooks = useDialog({ showDialog: false });
  const confirmDialogHooks = useConfirm({ showDialog: false });
  const feedbackHooks = useFeedback();
  const [target, setTarget] = React.useState(null);
  const tableHooks = useTable({
    deps: [],
    getList: (setTableData, setTotal, curPage, pageSize) =>
      RPCFactory.multiaccount
        .getBindList({
          pageIndex: curPage,
          pageSize,
        })
        .done((data) => {
          setTableData(data.entities);
          setTotal(data.size);
        })
        .fail((status, msg) => {
          feedbackHooks.showErrorTip(msg ? msg : '请求失败');
        }),
  });

  const renderID = (type, name, value, row) => {
    if (type == 'data') {
      if (row.subWeChatAppId && row.subWeChatAppId != '') {
        return row.subWeChatAppId;
      }
      return row.subAccountId;
    }
    return value;
  };

  const handleClick = (e, type, row) => {
    setTarget(e.target);
    confirmDialogHooks.openDialog({ type, row });
  };
  const renderOperation = (type, name, value, row) => {
    if (type == 'data') {
      if (value == bindStatus.binded) {
        return (
          <div>
            <span>已绑定</span>
          </div>
        );
      }
      if (value == bindStatus['pre-bind']) {
        const popoverstyle = {
          maxWidth: '450px',
        };
        const tips = '需要被绑定账户确认授权';
        const popover = (
          <PopOver style={popoverstyle}>
            <div className="poptable">{tips}</div>
          </PopOver>
        );

        return (
          <div>
            <span>
              待确认
              <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
                <i className="icon icon-help">
                  <i></i>
                </i>
              </OverlayTrigger>
            </span>
            <a
              className="a-link-primary"
              onClick={(e) => {
                handleClick(e, OPERATION_TYPE.withdrawBind, row);
              }}
            >
              解除绑定
            </a>
          </div>
        );
      }
      if (value == bindStatus.canceling) {
        return (
          <div>
            <span>解除中</span>
            <a
              className="a-link-primary"
              onClick={(e) => {
                handleClick(e, OPERATION_TYPE.confirmUnbind, row);
              }}
            >
              同意解绑
            </a>
          </div>
        );
      }
      return <div></div>;
    }
    return value;
  };

  const renderTable = () => (
    <Fragment>
      <div className="datalist">
        <Table data={tableHooks.data}>
          <Column name="subAccountId" render={renderID}>
            账号ID
          </Column>
          <Column name="subAccountName">主体名称</Column>
          <Column name="bindStatus" className="tb-action" render={renderOperation}>
            绑定状态
          </Column>
        </Table>
      </div>
      <PageBar {...tableHooks.pageBarAttr} />
    </Fragment>
  );
  return (
    <Fragment>
      <div className="toolbars">
        {isNormalAccount() ? (
          <p className="toolbar-tips">添加绑定账号后，您将自动升级为主账号，主账号可直接查看您绑定的子账号的线索数据。</p>
        ) : null}
        <div className="toolbar table-toolbar">
          <div className="toolbar-left">
            <Button
              displayType="primary"
              onClick={() => {
                bindDialogHooks.showAsAddModel();
              }}
            >
              <Icon type="add" />
              添加绑定账号
            </Button>
          </div>
        </div>
      </div>
      {tableHooks.tableLoading ? <Loading /> : renderTable()}
      {bindDialogHooks.showDialog ? (
        <Dialog
          {...bindDialogHooks}
          hideFooter
          backdrop
          title="添加绑定账号"
          style={{ width: '540px' }}
          className={'modal-normal'}
        >
          <Bind
            feedbackHooks={feedbackHooks}
            onCancel={bindDialogHooks.onCancel}
            onSubmit={() => {
              bindDialogHooks.onSubmit();
              tableHooks.reloadTable();
            }}
          />
        </Dialog>
      ) : null}
      <FeedBackDialog {...feedbackHooks} />
      {confirmDialogHooks.show ? (
        <Confirm
          {...confirmDialogHooks}
          target={target}
          onSubmit={() => {
            confirmDialogHooks.onSubmit();
            tableHooks.reloadTable();
          }}
          feedbackHooks={feedbackHooks}
        />
      ) : null}
    </Fragment>
  );
};

export default MyTable;
